import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const ParentMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.home',
        link: '/home',
    },
    {
        type: 'linkGroup',
        label: 'navigation.contents',
        links: [
            {
                type: 'link',
                label: 'navigation.corpus_global',
                link: '/corpus/11057',
            },
            {
                type: 'link',
                label: 'navigation.self_training_parent',
                link: '/further/formations',
            },
            {
                type: 'link',
                label: 'navigation.lessons',
                link: '/lessons/list',
            },
        ],
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
            },
            {
                type: 'link',
                label: 'navigation.contact',
                link: '/page/feedback',
            },
            {
                type: 'link',
                label: 'navigation.who_are_we',
                link: '/page/qui-sommes-nous',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '/page/site-map',
            },
        ],
    },
];
